export function mapStreckeToCreateValues(strecke) {
  return {
    Betriebsjahr_Id: strecke?.Betriebsjahr_Id ?? "",
    Datum: strecke?.Datum ?? "",
    JaegerId: strecke?.JaegerId ?? "",
    WildId: strecke?.WildId ?? "",
    Wildname: strecke?.Wildname ?? strecke?.wildname ?? "",
    Altersklasse: strecke?.Altersklasse ?? "",
    Wildalter: strecke?.Wildalter ?? "",
    Gewicht: strecke?.Std_Einheit === "kg" ? strecke?.Gewicht ?? "" : "",
    Anzahl: strecke?.Std_Einheit === "Stk" ? strecke?.Anzahl ?? 1 : 1,
    Geschlecht: strecke?.Geschlecht ?? "",
    Ort: strecke?.Ort ?? "",
    EinrichtungID: strecke?.EinrichtungID ?? null,
    EinrichtungName: strecke?.EinrichtungName ?? "",
    Bemerkung: strecke?.Bemerkung ?? "",
    Zerleger: strecke?.Zerleger ?? "",
    Zerlegedatum: strecke?.Zerlegedatum ?? "",
    Zerlegekosten: strecke?.Zerlegekosten ?? ""
  };
}

// Only Strecke quantities use zero as "not recorded".
export function formatStreckeQuantity(strecke) {
  const unit = strecke?.Std_Einheit;
  const value = unit === "kg" ? strecke?.Gewicht : unit === "Stk" ? strecke?.Anzahl : null;
  if (value == null || !Number.isFinite(Number(value)) || Number(value) === 0) return "";
  return `${value} ${unit === "kg" ? "kg" : "Stk."}`;
}

export function formatVerkaufStreckeQuantity(verkauf) {
  return formatStreckeQuantity({
    Std_Einheit: verkauf.w_std_einheit,
    Gewicht: verkauf.s_gewicht,
    Anzahl: verkauf.s_anzahl
  });
}
